import classnames from "classnames";
import { FieldError, RegisterOptions, UseFormMethods } from "react-hook-form";
import "./SimpleInput.style.scss";

interface SimpleInputProps {
  register: UseFormMethods["register"];
  type: "text" | "number" | "email" | "password" | "tel";
  rules?: RegisterOptions;
  autoComplete?: string;
  placeholder?: string;
  dataRecurly?: string;
  disabled?: boolean;
  optional?: boolean;
  error?: FieldError;
  label?: string | JSX.Element;
  className?: string;
  size?: number;
  help?: string;
  name: string;
}

export function SimpleInput({
  register,
  autoComplete,
  dataRecurly,
  placeholder,
  className,
  disabled,
  optional,
  error,
  rules,
  label,
  name,
  type,
  help,
  size,
}: SimpleInputProps) {
  return (
    <div className={`form-ctrl form-ctrl-simple form-ctrl-${type} ${className || ""}`}>
      {label ? (
        <label className={classnames({ optional })} htmlFor={name}>
          {label}
        </label>
      ) : null}
      <input
        {...(dataRecurly ? { "data-recurly": dataRecurly } : {})}
        className={classnames({ "has-error": !!error })}
        {...(autoComplete ? { autoComplete } : {})}
        {...(placeholder ? { placeholder } : {})}
        {...(size ? { size } : {})}
        aria-invalid={error ? "true" : "false"}
        {...(disabled ? { disabled } : {})}
        ref={register(rules)}
        type={type}
        id={name}
        name={name}
      />
      {error ? <span className="form-error">{error.message || "Error"}</span> : null}
      {help ? <span className="form-help">{help}</span> : null}
    </div>
  );
}
